import * as flagrApi from './flagrApi'
import { flags } from './constants'
import { ExperimentFlags, InternalFlags } from './store'
import { datadogRum } from '@datadog/browser-rum'

const isExperimentFlag = name => name.startsWith('my-pga-com-exp')

/* eslint-disable no-unused-vars */
const valueFlag = name => ({ name, init: value => value })
const booleanFlag = name => ({ name, init: value => value === 'true' })

const FLAGS = [
  booleanFlag(flags.FLAG_EXPEDITED_SHIPPING_DISABLED),
  booleanFlag(flags.FLAG_FEAT_GROUP_EVENT_RECURRING_PAYMENTS_ENABLED),
  booleanFlag(flags.FLAG_STUDENT_REVENUE_STAT),
  booleanFlag(flags.FLAG_FEAT_ENFORCE_FCC),
  booleanFlag(flags.FLAG_FEAT_BYPASS_JRL_REG),
  booleanFlag(flags.FLAG_FEAT_COACH_BUSINESS_INSIGHTS),
  booleanFlag(flags.FLAG_FEAT_COACH_ANALYTICS),
  booleanFlag(flags.FLAG_FEAT_COACH_LEAD_AUTO_REPLY),
  booleanFlag(flags.FLAG_FEAT_REMOVE_PUBLIC_PRIVATE_FACILITY_CHECK),
  booleanFlag(flags.FLAG_FEAT_JRL_9U_DIVISION),
  booleanFlag(flags.FLAG_ACCOUNT_SETUP_PAYMENT_LINKS),
  booleanFlag(flags.FLAG_LESSON_PACK_PAYMENT_INTENTS),
  booleanFlag(flags.FLAG_PRACTICE_SESSIONS_PAYMENT_INTENTS),
  booleanFlag(flags.FLAG_ADD_REMOVE_GROUP_CHANNEL_MEMBERS),
  booleanFlag(flags.FLAG_FAMILY_GOLF_REDIRECTS_ENABLED),
  booleanFlag(flags.FLAG_GROUP_EVENT_PAYMENT_INTENTS),
]

const initializeFeatures = async user => {
  // retrieve experiment flag values from previous visits
  // also apply any internal overrides from /ab
  let flagValues = {
    ...ExperimentFlags.get(),
    ...InternalFlags.get(),
  }

  // get the list of active flags for this application
  let activeFlagKeys = new Set()
  try {
    activeFlagKeys = await flagrApi.fetchActiveFlagKeys()

    // perform evaluations for any flags the user has not been evaluated for
    const userFlagKeys = new Set(Object.keys(flagValues))
    const flagKeysToEvaluate = Array.from(activeFlagKeys).filter(
      k => !userFlagKeys.has(k),
    )
    if (flagKeysToEvaluate.length > 0) {
      const flagEvaluations = await flagrApi.evaluateFlags(
        flagKeysToEvaluate,
        user,
      )
      flagValues = {
        ...flagValues,
        ...flagEvaluations,
      }
    }
  } catch (e) {
    window.rg4js &&
      window.rg4js('send', {
        error: e,
        tags: ['flagr'],
      })
  }

  // prune any inactive flags
  flagValues = Object.keys(flagValues)
    .filter(f => activeFlagKeys.has(f))
    .reduce((acc, val) => {
      acc[val] = flagValues[val]
      return acc
    }, {})

  // set the experiment flag cookie for future visits
  if (user != null) {
    const experimentFlagValues = Object.keys(flagValues)
      .filter(f => isExperimentFlag(f))
      .reduce((acc, val) => {
        acc[val] = flagValues[val]
        return acc
      }, {})
    ExperimentFlags.set(experimentFlagValues)
  }

  const evaluatedFlags = FLAGS.reduce(
    (acc, flag) => ({
      ...acc,
      [flag.name]: flag.init(flagValues[flag.name]),
    }),
    {},
  )

  for (const [key, value] of Object.entries(evaluatedFlags)) {
    datadogRum.addFeatureFlagEvaluation(key, value)
  }

  return evaluatedFlags
}

export default initializeFeatures
